<template>
  <cTable
    :fields="fields"
    :header="header"
    :methods="methods"
    :modals="modals"
    :config="config"
    :footer="footer"
    ref="table"
  >
  </cTable>
</template>

<script>
import cTable from "@/base/common/index";
import { apis } from "@/api/order/inboundNotBagged";
export default {
  name: "inboundNotBagged",
  components: {
    cTable,
  },
  data() {
    return {
      methods: {
        ...apis,
      },
      config: {
        isGetList: true,
      },
      footer: {},
      modals: {},
      header: {
        searchs: [
          {
            key: "startTime",
            placeholder() {
              return this.$tz("请选择,开始,日期");
            },
            component: "DatePicker",
            bind: {
              options: {
                disabledDate(time) {
                  return time.getTime() > Date.now();
                },
              },
              style: {
                width: "150px",
              },
            },
          },
          {
            key: "endTime",
            placeholder() {
              return this.$tz("请选择,结束,日期");
            },
            component: "DatePicker",
            bind: {
              options: {
                disabledDate(time) {
                  return time.getTime() > Date.now();
                },
              },
              style: {
                width: "150px",
              },
            },
          },
          {
            key: "client_id",
            placeholder() {
              return this.$tz("客户名称");
            },
            component: "Select",
            options: [],
            optionsFn: "customer",
            optionsKey: "",
          },
          {
            key: "toCountry",
            placeholder() {
              return this.$tz("目的国家");
            },
            component: "Select",
            options: [],
            optionsFn: "toCountry",
            optionsKey: "",
          },
        ],
        btns: {
          list: [
            {
              name: () => this.$tz("导出"),
              type: "export",
              fnName: "export",
              bind: {
                type: "primary",
              },
              disabled() {
                return !this.selectAll.length;
              },
            },
          ],
          methods: {
            export() {
              this.exportExc();
            },
          },
        },
      },
      fields: [
        {
          type: "checkbox",
          align: "center",
          width: 60,
        },
        {
          name: () => this.$tz("订单号"),
          key: "airway_number",
          minWidth: 110,
        },
        {
          name: () => this.$tz("目的国家"),
          key: "to_country",
          minWidth: 110,
        },
        {
          name: () => this.$tz("入库重量"),
          key: "check_weight",
          minWidth: 110,
        },
        {
          name: () => this.$tz("入库时间"),
          key: "inbound_time",
          minWidth: 110,
        },
      ],
    };
  },
};
</script>

<style scoped>
</style>